import { render } from "./FileVisualizer.vue?vue&type=template&id=18629bb1&scoped=true"
import script from "./FileVisualizer.vue?vue&type=script&lang=js"
export * from "./FileVisualizer.vue?vue&type=script&lang=js"

import "./FileVisualizer.vue?vue&type=style&index=0&id=18629bb1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18629bb1"]])

export default __exports__